export const env = {
  MONARCH_API_BASE_URL: process.env.REACT_APP_MONARCH_API_BASE_URL,
  ARCH_API_BASE_URL: process.env.REACT_APP_ARCH_API_BASE_URL,
  ARCH_APP_URL: process.env.REACT_APP_ARCH_APP_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
  CUBE_API_URL: process.env.REACT_APP_CUBE_API_URL,
  ARCH_SERVERLESS_URL: process.env.REACT_APP_ARCH_SERVERLESS_URL,
  ARCH_SERVERLESS_URL_SEC: process.env.REACT_APP_ARCH_SERVERLESS_URL_SEC,
};
